import axios from 'axios';

import { AddLeadDto } from '../interfaces/add-lead-manually.interface';

class LeadsService {
  async add(data: AddLeadDto): Promise<void> {
    return await axios.post('leads', data);
  }
}

export default new LeadsService();
